import { Navigate, Outlet } from 'react-router-dom';
import { useClientAccess } from './useClientAccess';

/* Gate report routes: Contributors (contentIQ + Expert Studio only) are sent to
   contentIQ. UX only — report APIs also reject Contributors server-side. */
export function RequireReports() {
  const { access, isLoading } = useClientAccess();
  if (isLoading || !access) return null; // brief; /api/me is cached after first load
  if (access.canReports) return <Outlet />;
  return <Navigate to={access.canContent ? '/content' : '/studio'} replace />;
}
